<template>
<popup-alert
  :title="title"
  btn_cancel
  :btn_cancel_title="cancelTitle"
  :btn_submit_title="submitTitle"
  @close="close">

  <div class="alignR" style="padding-bottom:5px;" v-if="step <= stepViewMax">({{step}}/{{stepViewMax}})</div>
  
  <div class="survey WBkeepAll alignL"  v-if="step == 1">
    1. 렌터카, 영업용(택시 등),<br>
    단체소속(개인사업자/단체/법인) 차량입니까?
  </div>

  <div class="survey WBkeepAll alignL" v-else-if="step == 2">
    2. Z 시리즈, M시리즈: M 하이 퍼포먼스, <br>
    순수 전기차, 개조차량, 경주용, 시승용, <br>
    차량가액이 2.5억원 초과 또는 <br>
    적재중량 1.4톤 초과 차량입니까?<br>
    <!-- 2. 개조차량, 경주용, 시승용, 적재중량 1.4톤 초과, 프로토타입, 비포장도로용차량, 스포츠 카 및 가액이 2.5억원 초과 차량입니까? -->
  </div>

  <div class="survey WBkeepAll alignL" v-else-if="step == 3">
    3. BMW 공식서비스센터 이외의 정비소에서<br>
    사고 수리 이력이 있는 차량입니까?<br>
    (단, 사고차량 외형의 단순 복원 혹은 단순 교체 제외. <br>
    예: 범퍼 단순 복원, 사이드미러 교체)
  </div>

  <div class="survey WBkeepAll alignL" v-else-if="step == 4">
    4. 차량 등록일로부터 60개월 초과 <br>
    96개월 이하 차량입니까?
  </div>

  <div class="survey WBkeepAll alignL" v-else-if="step == 5">
    5. 주행거리가 180,000km 초과인 차량입니까?
  </div>

  <div class="survey WBkeepAll alignL" v-else-if="step == 6">
    이전에 응답해주신 5가지 문항에 대해 사실이 <br>
    아닌 것으로 확인 된 경우 보증수리가 불가 합니다.<br>
    이에 동의하십니까?
  </div>


</popup-alert>
</template>
<script>
import Const from '../../helpers/Const'
import PopupAlert from '@/components/Popup/PopupAlert.vue';

export default {
  components: {
    PopupAlert,
  },
  props: {},
  computed: {
    title() {
      return `${this.$store.state.insuranceName.toUpperCase()} <br> 가입 대상 여부 확인`;
    },
    cancelTitle(){
      return ([4,6].includes(this.step)) ? '아니오.(종료)' : '예(종료)';
    },
    submitTitle(){
      return ([4,6].includes(this.step)) ? '예(다음)' : '아니오.(다음)';
    }
  },
  data() {
    return {
      Const,
      step: 1,
      stepViewMax: 5,
      stepMax:6
    }
  },
  methods: {
    close(submit) {
      if(submit) {
        if(this.step === this.stepMax)
          this.$emit('close',true);
        else this.step += 1;
      } else {
        this.$emit('close', false);
        this.step = 1;
      }
    }
  },
}
</script>

<style lang="css" scoped>
.survey {
  margin:10px 0px;
}
</style>